import axios from 'axios';
import {
  ApiException,
  GPanelPermissionsModel,
  PermissionsModel,
} from '../../../../../../../types';

export const SHARED_DRIVE_MIME_TYPE = 'application/vnd.google-apps.drive';

export const SHARED_DRIVE_ROLE_OPTIONS: {
  value: PermissionsModel['role'];
  label: string;
}[] = [
  { value: 'reader', label: 'Viewer' },
  { value: 'commenter', label: 'Commenter' },
  { value: 'writer', label: 'Contributor' },
  { value: 'fileOrganizer', label: 'Content Manager' },
  { value: 'organizer', label: 'Manager' },
];

export interface SharedDriveMembersFormValues {
  aclResources: GPanelPermissionsModel[];
}

export interface NewMemberDefaults {
  docId: string;
  docOwner: string;
  docTitle: string;
}

export function buildNewSharedDriveMember(
  userEmail: string,
  selectedType: string | undefined,
  { docId, docOwner, docTitle }: NewMemberDefaults
): GPanelPermissionsModel {
  return {
    changeType: 'add',
    userEmail,
    role: 'reader',
    type: selectedType === 'group' ? 'group' : 'user',
    withLink: false,
    sendNotification: false,
    transferOwnership: false,
    additionalRoles: [],
    isCommenter: false,
    photoLink: '',
    docId,
    mimeType: SHARED_DRIVE_MIME_TYPE,
    isPrimaryOwner: false,
    toBeDeleted: false,
    permExpirationTime: 0,
    permId: '',
    docOwner,
    docTitle,
    allowFileDiscovery: false,
    displayName: '',
    permissionDetails: [],
  };
}

export function getErrorReason(error: unknown) {
  if (axios.isAxiosError(error)) {
    const message = (error.response?.data as ApiException | undefined)?.message;
    if (message) return message;
  }
  if (error instanceof Error && error.message) return error.message;
  return 'Unknown error';
}
